import { makeObservable } from 'mobx';
import { ContactInfoStore } from './contact-info';
import { DesiredPositionStore } from './desired-position';
import { PersonalInfoStore } from './personal-info';

export class CreateResumeStore {
    constructor(
        public readonly personalInfo: PersonalInfoStore,
        public readonly contactInfoStore: ContactInfoStore,
        public readonly desiredPosition: DesiredPositionStore
    ) {
        makeObservable(this);
    }
}
